<template>
  <div class="app-page-cs" :class="(($store.state.aviso_menu.length >= 1 && $store.state.token.pdv === true) ? 'pdv-com-aviso' : '') + ' ' + ($store.state.mobile === true ? 'app-page-cs-mobile' : '')">
    <template v-if="rotaCS !== null && rotaCS.hasOwnProperty('post') && typeof rotaCS.post === 'object' && Object.keys(rotaCS.post).length >= 1  && !rotaCS.post.hasOwnProperty('features')">
      <iframe id="rf-pagina-projeto-cs" name='rf-pagina-projeto-cs' :class="(((rotaCS.hasOwnProperty('menu') && rotaCS.menu === false) || $store.state.token.pdv === true) ? 'iframe-sem-menu' : 'iframe-com-menu') + ' ' + ('iframe-padding-bottom-' + (Object.keys(rotaCS.post).length === 0 || !rotaCS.post.hasOwnProperty('features')).toString())"></iframe>
    </template>
    <template v-else-if="rotaCS !== null && rotaCS.hasOwnProperty('post') && typeof rotaCS.post === 'object' && Object.keys(rotaCS.post).length >= 2 && rotaCS.post.hasOwnProperty('features')">
      <iframe id="rf-pagina-projeto-cs" name='rf-pagina-projeto-cs' :class="(((rotaCS.hasOwnProperty('menu') && rotaCS.menu === false) || $store.state.token.pdv === true) ? 'iframe-sem-menu' : 'iframe-com-menu') + ' ' + ('iframe-padding-bottom-' + (Object.keys(rotaCS.post).length === 0 || !rotaCS.post.hasOwnProperty('features')).toString())"></iframe>
    </template>
    <template v-else-if="url !== ''">
      <iframe id="rf-pagina-projeto-cs" :class="(((rotaCS.hasOwnProperty('menu') && rotaCS.menu === false) || $store.state.token.pdv === true) ? 'iframe-sem-menu' : 'iframe-com-menu') + ' ' + ('iframe-padding-bottom-' + ((Object.keys(rotaCS.post).length === 0 || !rotaCS.post.hasOwnProperty('features')) === true && $store.state.token.pdv === false).toString())" v-if="url !== ''" :src="url"></iframe>
    </template>
  </div>
</template>

<style scoped>
/* .app-page-cs {
  padding: 30px;
} */

  iframe {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    border: none;
  }
  .app-page-cs:not(.app-page-cs-mobile) > iframe {
    position: absolute;
    top: 0px;
    height: 100vh;
  }
  .app-page-cs:not(.app-page-cs-mobile) > iframe.iframe-com-menu {
    top: 80px;
  }
  .app-page-cs:not(.app-page-cs-mobile) > iframe.iframe-padding-bottom-true {
    height: calc(100vh - 70px) !important;
  }
  .pdv-com-aviso > iframe {
    margin-top: 15px;
  }

  .app-page-cs-mobile > iframe {
    height: 10200px;
    /* min-height: 100vh; */
  }
</style>

<style>
  .web-page-cs {
    overflow: hidden !important;
    overflow-y: hidden !important;
  }
    .web-page-cs > #rotina-facil-web > #rf-web-body > #rf-header-body ~ .rf-conteudo {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      padding: 0px !important;
    }
</style>

<script>
  export default {
    data: function () {
      return {
        url: '',
        rotaCS: null,
        pdv: false
      }
    },
    mounted: function () {
      this.csProjetoIniciar()
    },
    methods: {
      csProjetoIniciar: function () {
        var self = this

        // PEGA OS DADOS RECEBIDOS
        self.rotaCS = JSON.parse(window.atob(decodeURI(self.$route.params.rotaB64)))

        if (self.rotaCS.url === self.url) {
          // LIMPA A URL DA PAGINA ATULA
          self.url = ''

          // CHAMA A FUNÇÃO NOVAMENTE PARA RECARREGAR A PAGINA
          setTimeout(function () {
            self.csProjetoIniciar()
          }, 100)
        } else {
          // VERIFICA SE TEM DADOS PARA SEREM ENVIADOS VIA POST
          if (self.rotaCS.hasOwnProperty('post') && typeof self.rotaCS.post === 'object' && Object.keys(self.rotaCS.post).length >= 1 && !self.rotaCS.post.hasOwnProperty('features')) {
            setTimeout(function () {
              self.$store.state.OPEN_PAGE_CS(self.rotaCS.url, self.rotaCS.target, self.rotaCS.post)
            }, 500)
          } else if (self.rotaCS.hasOwnProperty('post') && typeof self.rotaCS.post === 'object' && Object.keys(self.rotaCS.post).length >= 2 && self.rotaCS.post.hasOwnProperty('features')) {
            setTimeout(function () {
              // MONTA O FORMULARIO
              var form = $('<form></form>')
                .attr('method', 'post')
                .attr('action', self.rotaCS.url)
                .attr('target', 'rf-pagina-projeto-cs')

              // ADICIONA TODOS OS INPUT AO FORMULARIO
              for (var key in self.rotaCS.post) {
                var field = $('<input></input>')
                  .attr('type', 'hidden')
                  .attr('name', key)
                  .attr('value', self.rotaCS.post[key])
                form.append(field)
              }

              // SALVA O FORMULARIO NO HTML
              $(document.body).append(form)

              // ENVIA O FORMULARIO PARA O URL INFORMADO
              form.submit()
            }, 500)
          } else {
            self.url = self.rotaCS.url
          }

          if (self.rotaCS.hasOwnProperty('menu') && self.rotaCS.menu === false) {
            self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
          }

          // // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          // self.$store.commit('SET_REFRESH_ROUTE', self.$route.name)

          // CHAMA A FUNÇÃO PARA FECHAR O CHAT
          if (Object.keys(self.$store.state.atalhos).length >= 1 && [ '', null, undefined ].indexOf(self.$store.state.atalhos['ALT+A']) === -1 && self.$store.state.atalhos['ALT+A'].mostrar === true) {
            self.$store.commit('EXECUTE_ATALHO', 'ALT+A')
          }
        }
      }
    },
    watch: {
      '$route.params.rotaB64': function () {
        this.csProjetoIniciar()
      }
    }
  }
</script>
